class VariantSlits extends HTMLElement {
  constructor() {
    super();

    // Default to null since slit variation is unselected on page load
    this.state = {
      slit: null,
    };
  }

  connectedCallback() {
    this.initializeElements();
    this.initializeListeners();
    this.render();
  }

  render() {
    this.updateState();
    this.updateUI();
  }

  updateState() {
    // Receive state updates here
    let currentSelectedSlit = this.getProductState("slit");

    // Lowercase it to standardize
    currentSelectedSlit = currentSelectedSlit.toLowerCase();

    this.state.slit = currentSelectedSlit;
  }

  updateUI() {
    const currentSelectedSlit = this.state.slit;

    if (!currentSelectedSlit) return;

    Array.from(this.slitSelectors).forEach((selector) => {
      const selectorValue = String(selector.value).toLowerCase();
      if (selectorValue === currentSelectedSlit) {
        selector.click();
      }
    });
  }

  initializeElements() {
    this.productState = document.querySelector("product-state");
    this.slitSelectors = this.querySelectorAll(".slit-variation-radio");
  }

  initializeListeners() {
    Array.from(this.slitSelectors).forEach((selector) => {
      selector.addEventListener("click", () => {
        // Update ProductState with clicked value
        this.setProductState("slit", selector.value);
      });
    });
  }

  /**
   * This updates the state from product-state.
   *
   * @param {*} state - The state or attribute to get.
   * @returns {string} value
   */
  getProductState = (state) => {
    const value = this.productState.getAttribute(state);

    return value;
  };

  /**
   * This updates the state from product-state.
   *
   * @param {*} state - The state or attribute to set.
   * @param {*} value - The new value it will be set to.
   */
  setProductState = (state, value) => {
    this.productState.setAttribute(state, value);
  };
}

export default VariantSlits;
